// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-general-end-phases {
    display: flex;
    flex-direction: row;
    gap: var(--space);
    justify-content: center;
    margin-top: var(--space-and-half);
    flex-wrap: wrap;
    max-height: 80vh;
}

.tournament-general-end-phase-teams {
    background: #FFFFFF;
    border: 2px solid #F3F5F7;
    border-radius: 7.85333px;
    padding: var(--space-x2);
    width: 49%;
    margin-right: auto;
}

.tournament-general-end-phase-team_information {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #E7E7E7;
    padding: 19px 31px;
    width: auto;
    align-items: center;
}

.tournament-end-phases_container {
    background: #FFFFFF;
    border-radius: 8px;
    padding: var(--space-x2);
}

.tournament-end-phases_text_information {
    margin: 0 var(--space);
}

.tournament-end-phases_container .tournament-end-phases_text_information .tournament-edit-tournament__classified {
    margin-left: 0;
}

.tournament-end-phases_text_information .end-phases-subtitle {
    margin-top: var(--space-and-half)
}

.phases-teams--list__photo {
    width: 35px;
    height: 35px;
    border-radius: 50%;
}

.tournament-general-end-phase-team_photo_inf {
    display: flex;
    gap: var(--space);
    align-items: center;
}

.tournament-general-end-phases-team-status-best-third {
    width: 4px;
    height: 49px;
    border-radius: 9px;
}

.tournament-general-end-phases-team-status-best-third.classified{
    background-color: var(--new-green-color);
}

.tournament-general-end-phases-team-status-best-third.best-third{
    background: #FA7B17;
}

.tournament-general-end-phases-teams-best_thirds_group{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: var(--space);
}

.tournament-general-end-phases-teams-best_thirds_group .baloa-names{
    color: var( --primary-dark-color)
}

.tournament-general-end-phases-teams-best_thirds_group .best_thirds_group.baloa-names{
    color: var(--basic-gray-color)
}

.tournament-general-end-phase-team_information .tournament-general-end-phase-team_photo_inf .icon-ball{
    color: var( --white-color );
    font-size: var( --space-and-half );
    border-radius: 50%;
    padding: var( --space-quarter );
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-general-end-phases/TournamentGeneralEndPhasesComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;IACxB,wBAAwB;IACxB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;AACnC","sourcesContent":[".tournament-general-end-phases {\n    display: flex;\n    flex-direction: row;\n    gap: var(--space);\n    justify-content: center;\n    margin-top: var(--space-and-half);\n    flex-wrap: wrap;\n    max-height: 80vh;\n}\n\n.tournament-general-end-phase-teams {\n    background: #FFFFFF;\n    border: 2px solid #F3F5F7;\n    border-radius: 7.85333px;\n    padding: var(--space-x2);\n    width: 49%;\n    margin-right: auto;\n}\n\n.tournament-general-end-phase-team_information {\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 1px solid #E7E7E7;\n    padding: 19px 31px;\n    width: auto;\n    align-items: center;\n}\n\n.tournament-end-phases_container {\n    background: #FFFFFF;\n    border-radius: 8px;\n    padding: var(--space-x2);\n}\n\n.tournament-end-phases_text_information {\n    margin: 0 var(--space);\n}\n\n.tournament-end-phases_container .tournament-end-phases_text_information .tournament-edit-tournament__classified {\n    margin-left: 0;\n}\n\n.tournament-end-phases_text_information .end-phases-subtitle {\n    margin-top: var(--space-and-half)\n}\n\n.phases-teams--list__photo {\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n}\n\n.tournament-general-end-phase-team_photo_inf {\n    display: flex;\n    gap: var(--space);\n    align-items: center;\n}\n\n.tournament-general-end-phases-team-status-best-third {\n    width: 4px;\n    height: 49px;\n    border-radius: 9px;\n}\n\n.tournament-general-end-phases-team-status-best-third.classified{\n    background-color: var(--new-green-color);\n}\n\n.tournament-general-end-phases-team-status-best-third.best-third{\n    background: #FA7B17;\n}\n\n.tournament-general-end-phases-teams-best_thirds_group{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: var(--space);\n}\n\n.tournament-general-end-phases-teams-best_thirds_group .baloa-names{\n    color: var( --primary-dark-color)\n}\n\n.tournament-general-end-phases-teams-best_thirds_group .best_thirds_group.baloa-names{\n    color: var(--basic-gray-color)\n}\n\n.tournament-general-end-phase-team_information .tournament-general-end-phase-team_photo_inf .icon-ball{\n    color: var( --white-color );\n    font-size: var( --space-and-half );\n    border-radius: 50%;\n    padding: var( --space-quarter );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
